import { GrowthBook } from "@growthbook/growthbook-react";
import Cookies from 'js-cookie';

export default function getOrCreateGrowthbookClient() {
  if (!window.gbClientApurata) {
    const attributeId = Cookies.get('apurataSessionId');
    window.gbClientApurata = new GrowthBook({
      apiHost: 'https://cdn.growthbook.io',
      clientKey: import.meta.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
      // Enable easier debugging during development
      enableDevMode: import.meta.env.REACT_APP_ENV === 'local',
      // Update the instance in realtime as features change in GrowthBook
      subscribeToChanges: import.meta.env.REACT_APP_ENV === 'local',
      attributes: {
        id: attributeId,
      },
      // Only required for A/B testing
      // Called every time a user is put into an experiment
      trackingCallback: (experiment, result) => {
        window.dataLayer.push({
          attributeId,
          event: 'experiment_viewed',
          experimentId: experiment.key,
          variationId: result.key,
        });
      },
    });
  }
  return window.gbClientApurata;
}
